import React from 'react';
import { usePublicConfig } from '@pv/common/providers';

export const Logo = () => {
  const { publicConfig } = usePublicConfig();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div>
        <img
          alt="Perfect Venue"
          style={{
            width: 'auto',
            height: '40px',
          }}
          src={publicConfig?.images?.pvLogoName}
        />
      </div>
    </div>
  );
};
export default Logo;
